var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-layout',[_c('div',{staticClass:"companies"},[_c('v-tabs',{attrs:{"show-arrows":""},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tabs-slider'),_c('v-tab',{attrs:{"to":{
          name: 'CompanyShow',
          params: { companyId: _vm.$route.params.companyId }
        }}},[_vm._v(" Provider ")]),_c('v-tab',{attrs:{"to":{
          name: 'CompanyUsers',
          params: { companyId: _vm.$route.params.companyId }
        }}},[_vm._v(" Users ")]),_c('v-tab',{attrs:{"to":{
          name: 'CompanyFacilities',
          params: { companyId: _vm.$route.params.companyId }
        }}},[_vm._v(" Listings ")]),_c('v-tab',{attrs:{"to":{
          name: 'CompanyPricing',
          params: { companyId: _vm.$route.params.companyId }
        }}},[_vm._v(" Pricing ")]),_c('v-tab',{attrs:{"to":{
          name: 'CompanyPayments',
          params: { companyId: _vm.$route.params.companyId }
        }}},[_vm._v(" Payments ")])],1),_c('router-view'),_c('v-snackbar',{attrs:{"top":"","timeout":0,"color":"info"},model:{value:(_vm.showSnack),callback:function ($$v) {_vm.showSnack=$$v},expression:"showSnack"}},[_vm._v(" "+_vm._s(_vm.snackMsg)+" "),_c('v-btn',{attrs:{"text":""},on:{"click":function($event){_vm.showSnack = false}}},[_vm._v(" Close ")])],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }